var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "previous" }, [
    _c(
      "div",
      { staticClass: "previous__wrapper" },
      [
        _c("BaseTitle", {
          staticClass: "previous__title",
          attrs: { text: _vm.title, tag: "h1" }
        }),
        _c("div", { ref: "block", staticClass: "previous__years_block" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.disableControls,
                  expression: "!disableControls"
                }
              ],
              staticClass: "previous__controls"
            },
            [
              _c("button", {
                staticClass: "previous__controls-left",
                on: {
                  click: function($event) {
                    return _vm.scrollWrapper("prev")
                  }
                }
              }),
              _c("button", {
                staticClass: "previous__controls-right",
                on: {
                  click: function($event) {
                    return _vm.scrollWrapper("next")
                  }
                }
              })
            ]
          ),
          _c("div", { ref: "years", staticClass: "previous__years" }, [
            _c(
              "div",
              { ref: "wrapper", staticClass: "previous__years_wrapper" },
              _vm._l(_vm.allYears, function(year, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    class: [
                      "previous__year previous__year--" +
                        _vm.extractNumber(year),
                      { "previous__year--active": _vm.activeYear === year }
                    ],
                    attrs: { "data-year": year },
                    on: { click: _vm.toggleYear }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.extractNumber(year)))])]
                )
              }),
              0
            )
          ])
        ]),
        _c("PreviousContestCategory", { attrs: { year: _vm.currentYear } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-167ff76a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-167ff76a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PreviousContestBlock.vue
// module id = d2q1
// module chunks = 1